import { render } from "./TicketsReservation.vue?vue&type=template&id=5c26b10a&ts=true&lang=pug"
import script from "./TicketsReservation.vue?vue&type=script&lang=ts&setup=true"
export * from "./TicketsReservation.vue?vue&type=script&lang=ts&setup=true"

import "./TicketsReservation.vue?vue&type=style&index=0&id=5c26b10a&lang=scss"

import exportComponent from "/home/runner/work/affolterNET.Tickets/affolterNET.Tickets/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__